import { useStateContext } from "../../contexts/ContextProvider";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import moment from "moment";
import Select from "react-select";

const LeaveHistoryFilterModal = ({
  leaveCat,
  details,
  setDetails,
  checked,
  handleCheckedChange,
  handleFilter,
  clearFilter,
  appliedOn,
  setAppliedOn,
}) => {
  const { filterBy } = useStateContext();

  const currentDate = new Date();

  const handleSelectChange = (e) => {
    // console.log(e.value);
    setDetails((prev) => ({
      ...prev,
      leaveReason: e.label,
    }));
  };

  const handleChange = (e) => {
    setAppliedOn(e.value);
    setDetails({
      ...details,
      date: moment(new Date(e.value)).format("DD-MM-YYYY"),
      formatedDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  return (
    <>
      <div
        className={`${
          filterBy ? "filterByModal visible" : "filterByModal hidden"
        }`}
      >
        <div className="filter-flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Filter</span>
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Leave Reason
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={leaveCat}
                onChange={handleSelectChange}
                value={
                  Array.isArray(leaveCat)
                    ? leaveCat.filter(
                        (option) => option.label === details.leaveReason
                      )
                    : null
                }
              />
            </div>
            <div className="mb-3 calendar-relative">
              <label htmlFor="leaveType" className="form-label">
                Applied On
              </label>
              <Calendar
                value={appliedOn}
                onChange={handleChange}
                view="date"
                dateFormat="dd, MM, yy"
                style={{ width: "100%", height: "45px" }}
                showIcon
                maxDate={currentDate}
                selectOtherMonths
              />
            </div>

            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Status
              </label>

              <div className="statusFilter-flex statusFilter-flex2 visible">
                <div className="sort-flex">
                  <span className="status-filter pending">Pending</span>
                  <label className="radio-container">
                    <input
                      type="radio"
                      checked={checked === "0"}
                      onChange={handleCheckedChange("0")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <span className="status-filter rejected">Rejected</span>
                  <label className="radio-container">
                    <input
                      type="radio"
                      checked={checked === "2"}
                      onChange={handleCheckedChange("2")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <span className="status-filter approved">Approved</span>
                  <label className="radio-container">
                    <input
                      type="radio"
                      checked={checked === "1"}
                      onChange={handleCheckedChange("1")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-reset" onClick={clearFilter}>
              Reset
            </button>
            <button className="btn btn-apply" onClick={handleFilter}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveHistoryFilterModal;
